import { ActionType } from "../action-types";
import { ConversationDto } from "../../dto/conversation";
import { Action } from "../actions";

export type ConversationsState = {
  items: ConversationDto[];
  query: string;
  page: number;
  pageSize: number;
  totalItems: number;
};

const initialState: ConversationsState = {
  items: [],
  query: "",
  page: 1,
  pageSize: 25,
  totalItems: 0,
};

export type ConversationsPagedPayload = {
  items: ConversationDto[];
  page?: number;
  pageSize?: number;
  totalItems?: number;
  query?: string;
};

const conversationsReducer = (
  state: ConversationsState = initialState,
  action: Action
): ConversationsState => {
  switch (action.type) {
    case ActionType.SET_CONVERSATIONS: {
      const payload = action.payload as
        | ConversationDto[]
        | ConversationsPagedPayload;

      if (Array.isArray(payload)) {
        return {
          ...state,
          items: payload,
          totalItems: payload.length,
        };
      }

      const {
        items,
        page = 1,
        pageSize = 25,
        totalItems = items.length,
        query = state.query,
      } = payload;

      const isReset = page === 1 || query !== state.query;
      const mergedItems = isReset ? items : [...state.items, ...items];

      return {
        ...state,
        items: mergedItems,
        page,
        pageSize,
        totalItems,
        query,
      };
    }

    case ActionType.NEW_FILTER_CONVERSATIONS: {
      const query = (action.payload ?? "").toString();

      return { ...state, query, page: 1 };
    }

    default:
      return state;
  }
};

export default conversationsReducer;
